/* unplugin-vue-components disabled */import { render } from "./NotificationHeaderList.vue?vue&type=template&id=6bd8d4ae&scoped=true&ts=true"
import script from "./NotificationHeaderList.vue?vue&type=script&lang=ts"
export * from "./NotificationHeaderList.vue?vue&type=script&lang=ts"

import "./NotificationHeaderList.vue?vue&type=style&index=0&id=6bd8d4ae&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6bd8d4ae"]])

export default __exports__